<template>
  <!-- 영역 4 inventory 일별 변동 line chart — REQ-FE-DETAIL-005 -->
  <!-- chart.js@4.4.2 + vue-chartjs@5.3.0 (기존 dependency 답습, E-18) -->
  <div class="chart-container" data-testid="inventory-daily-trend-chart">
    <div v-if="loading" class="chart-loading">
      <a-skeleton active :paragraph="{ rows: 3 }" />
    </div>
    <div v-else-if="!dailyTrend || dailyTrend.length === 0" class="chart-no-data">
      <a-empty :description="$t('lotFlow_detail_chartNoData')" />
    </div>
    <div v-else style="height: 200px; position: relative;">
      <!-- @MX:NOTE: [AUTO] REQ-FE-DETAIL-005 — label은 productDescription 우선 (feedback_chart_label_name_first 룰 답습) -->
      <Line :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

export default {
  name: 'InventoryDailyTrendChart',
  components: { Line },
  props: {
    // 최근 60일 일별 quantity 변동 series (REQ-BE-EXT-010)
    dailyTrend: {
      type: Array,
      default: () => [],
    },
    // chart 라벨 이름 우선 (feedback_chart_label_name_first 룰)
    productDescription: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartLabel() {
      // @MX:NOTE: [AUTO] feedback_chart_label_name_first — GTIN 아닌 productDescription 우선
      return this.productDescription || this.$t('lotFlow_detail_field_quantity');
    },
    chartData() {
      return {
        labels: (this.dailyTrend || []).map((d) => d.date),
        datasets: [
          {
            label: this.chartLabel,
            data: (this.dailyTrend || []).map((d) => d.quantity),
            borderColor: '#1890ff',
            backgroundColor: 'rgba(24, 144, 255, 0.1)',
            fill: true,
            tension: 0.2,
            pointRadius: 2,
            pointHoverRadius: 4,
          },
        ],
      };
    },
    chartOptions() {
      const self = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              // title: 날짜
              title: (items) => (items[0] ? items[0].label : ''),
              // label: productDescription 우선 (feedback_chart_label_name_first 룰)
              label: (item) => `${self.chartLabel}: ${item.raw}`,
            },
          },
        },
        scales: {
          x: {
            ticks: {
              maxTicksLimit: 8,
              font: { size: 11 },
            },
          },
          y: {
            beginAtZero: true,
            ticks: { font: { size: 11 } },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
}
.chart-loading,
.chart-no-data {
  padding: 16px 0;
}
</style>
